import { render, staticRenderFns } from "./addTemplateModule.vue?vue&type=template&id=e12aad2c&scoped=true"
import script from "./addTemplateModule.vue?vue&type=script&lang=js"
export * from "./addTemplateModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12aad2c",
  null
  
)

export default component.exports